import React from 'react';
import { Button, ModalFooter } from '@axiom/ui';

export interface TalentInterviewModalFooterProps {
  name: string;
  onClose: () => void;
  onBack?: () => void;
  onContinue: () => void | Promise<void>;
}

export const TalentInterviewModalFooter = ({
  name,
  onClose,
  onBack,
  onContinue,
}: TalentInterviewModalFooterProps) => {
  return (
    <ModalFooter name={name} stackableOn="mobile">
      <Button
        name={`${name}_CANCEL_BUTTON`}
        onClick={() => {
          onClose();
        }}
        variation="minimal"
      >
        CANCEL
      </Button>
      {onBack ? (
        <Button
          name={`${name}_BACK_BUTTON`}
          onClick={() => {
            onBack();
          }}
          variation="outline"
        >
          Back
        </Button>
      ) : null}
      <Button
        name={`${name}_CONTINUE_BUTTON`}
        onClick={async () => onContinue()}
      >
        Continue
      </Button>
    </ModalFooter>
  );
};
